import { NavMarker } from 'react-rhumb';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { useLoginVerify } from '../hooks/useLoginVerify';
import { PublicPortalSettingsProvider, usePublicPortalSettings } from '../hooks/usePublicPortalSettings';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AppInitializationGate = ({
  children
}) => {
  const {
    loading: authLoading,
    isLoggedIn
  } = useLoginVerify();
  const {
    portalSettings,
    loading: portalSettingsLoading,
    error: portalSettingsError
  } = usePublicPortalSettings();
  const spinner = /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    blockSize: "100vh",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {})
  });
  if (authLoading) {
    return spinner;
  }
  if (!isLoggedIn) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "APP_NOT_INITIALIZED"
    });
  }
  const isPortalSettingsLoading = portalSettingsLoading || !portalSettings && !portalSettingsError;
  if (isPortalSettingsLoading) {
    return spinner;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export const AuthWrapper = ({
  children
}) => {
  return /*#__PURE__*/_jsx(PublicPortalSettingsProvider, {
    children: /*#__PURE__*/_jsx(AppInitializationGate, {
      children: children
    })
  });
};